import {useRef, useState} from 'react'
import {Button, type ButtonProps} from '@primer/react'

import {ResolveConflictsDialog} from '../../../common/ResolveConflictsDialog'

/**
 * CTA for the stack conflict scenarios. Stack conflicts must be resolved from the command
 * line, so this opens a dialog with the `gh stack` instructions rather than a web editor.
 */
export function ResolveConflictsButtonAndDialog({
  stackNumber,
  size,
}: {
  stackNumber: number
  size?: ButtonProps['size']
}) {
  const [showDialog, setShowDialog] = useState(false)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const closeDialog = () => {
    setShowDialog(false)
    buttonRef.current?.focus()
  }

  return (
    <>
      <Button ref={buttonRef} size={size} onClick={() => setShowDialog(true)}>
        Resolve conflicts
      </Button>
      {showDialog && (
        <ResolveConflictsDialog stackNumber={stackNumber} returnFocusRef={buttonRef} onClose={closeDialog} />
      )}
    </>
  )
}
